import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaClock } from "react-icons/fa"; 

function CourseslistPage() {
    const trainLoaderStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '150px',
        position: 'relative',
    };

    const trainStyle = {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        animation: 'moveTrain 4s linear infinite', // Slower animation
    };

    const carStyle = {
        width: '20px',
        height: '20px',
        backgroundColor: '#FF001E',
        margin: '0 5px',
        borderRadius: '4px',
    };

    const keyframesStyle = `
        @keyframes moveTrain {
            0% {
                left: -100px;
            }
            100% {
                left: 100%;
            }
        }
    `;
    const [categories, setCategories] = useState([]);
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);

    const location = useLocation();
    const selectedCategory = location.state?.selectedCategory || null;
    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}courses/getAllCourses`);
                const response = await axios.get(`https://api.itrain.io/courses/getAllCourses`);
                const data = response.data;
                const uniqueCategories = [
                    ...new Set(data.courses.map((course) => course.level)),
                ];
                setCategories(uniqueCategories);
                setCourses(data.courses);

                // Filter courses by selected category
                if (selectedCategory) {
                    const filtered = data.courses.filter(
                        (course) => course.courseCategory === selectedCategory
                    );
                    setFilteredCourses(filtered);
                } else {
                    setFilteredCourses(data.courses);
                }
            } catch (error) {
                // console.error("Error fetching course categories:", error);
            }
        };

        fetchCategories();
    }, [selectedCategory]);

    const handleViewDetails = (courseTitle) => {
        navigate('/courselevel', { state: { selectedCourseTitle: courseTitle } });
    };

    return (
        <section className="service-section bg-grey padding">
            <div className="map-pattern" />
            <div className="container">
                <div className="section-heading mb-30">
                    <h2>Courses</h2>
                </div>
                <div className="row gy-4">
                {filteredCourses.length > 0 &&
    [...new Map(filteredCourses.map((course) => [course.courseTitle, course])).values()] // Filter unique course titles
        .map((course, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
                <div
                    className="service-item wow fade-in-bottom"
                    data-wow-delay="100ms"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        minHeight: '350px',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                    }}
                >
                    <div className="service-thumb">
                        <img
                            src={course.courseThumbnail}
                            alt="thumb"
                            style={{
                                width: '100%',
                                height: '200px',
                                objectFit: 'cover',
                            }}
                        />
                    </div>
                    <div
                        className="service-content"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            flexGrow: 1,
                            padding: '15px',
                        }}
                    >
                        <div className="d-flex justify-content-between">
                            <div>
                                <h3 style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                    <a href={course.link}>{course.courseTitle}</a>
                                </h3>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <span
                                    className="text-13 py-2 px-10 rounded-pill"
                                    style={{
                                        display: 'inline-block',
                                        padding: '10px',
                                        borderRadius: '10px',
                                        backgroundColor: '#FF001E',
                                        color: '#fff',
                                    }}
                                >
                                    {course.courseCategory}
                                </span>
                            </div>
                        </div>
                        <button
                            onClick={() => handleViewDetails(course.courseTitle)}
                            className="read-more"
                            style={{
                                backgroundColor: '#FF001E',
                                color: '#fff',
                                border: 'none',
                                padding: '10px',
                                borderRadius: '5px',
                            }}
                        >
                            View Details
                        </button>
                    </div>
                </div>
            </div>
        ))
}

                </div>
            </div>
        </section>
    );
}

export default CourseslistPage;